(ns app.survey.login.email.state)

(def states
  [::none
   ::auth-ok
   ::checking-email
   ::sent-email-token
   ::logged-out
   ::logging-out])
